export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface CurrentUserBodyRequest {
	conference?: string
	currentPosition?: string;
	firstName: string;
	introduction?: string;
	isReachableByCall: boolean;
	isReachableByText: boolean;
	languages?: string[];
	lastName: string;
	location: string;
	mentoringScopes?: string[];
	pronouns?: 'she_her' | 'he_him' | 'they_them';
	researchAreas?: string[];
	title?: 'ms' | 'mrs' | 'mr' | 'dr';
}

export interface WorkExperience {
	[key: string]: any;

	description?: string;
	currentPosition: string;
	endDate?: string | any;
	institution: string;
	location: string;
	startDate: string | any;
	workExperienceId?: string;
}

export interface Education {
	description?: string;
	educationId?: string;
	endDate?: string;
	institution: string;
	location: string;
	obtainedDegree: string;
	startDate: string;
}

export interface Article {
	articleId: string;
	authors: string[];
	description?: string;
	link?: string;
	publishedIn: string;
	publishingLocation: string;
	publishingYear: string;
	title: string;
	tags: string[];
}

export interface Conference{
	date: string
	id: string
	name: string
}